export const BASE_URL = "https://fmservicehub.com/api/";   // Local Url
export const BASE_URL1 = "http://localhost:4008/";      // Local 

// export const BASE_URL = "http://192.168.1.41:4008/";   // Local Url
// export const BASE_URL1 = "http://192.168.1.41:4008/";      // Local 

// auth user
export const signupEndPointURL = "users/signup";
export const loginEndPointURL = "users/login";


export const forgotPasswordEndPointURL = "users/forgetPassword";

// Tooltip / Guided Tour
export const tooltipSeenEndPointURL = "users/tooltip-seen";

// Dashboard Data
export const getDashboardDataEndPointURL = "home/getHome";
export const getTomorrowTaskEndPointURL = "home/tasksForTommorrow";


export const getStaffTaskEndPointURL = "home/staffMembers";

// Bussiness profile
export const bussinessProfileEndPointURL = "users/myProfile";
export const updateBussinessProfileEndPointURL = "users/editProfile";
export const changePasswordEndPointURL = "users/change-password-api";
export const activeServiceCategoriesEndPointURL =
  "category/service-categories/active";

// staff
export const addStaffEndPointURL = "staff/addStaffMember";
export const rolesAPI = "staff/roles";
export const getStaffDataEndPointURL = "staff/staffMembers";
export const technicianDataAPI = "staff/staffMember/";
export const toggleTechnicianStatusAPI = "users/toggle-technician-status/";

export const updateStaffEndPointURL = "staff/editStaffMember";
export const getActiveStaffDataEndPointURL = "staff/activeStaffMembers";

// supplier
export const getSupplierEndPointURL = "supplier/getAllSupplier";
export const addSupplierEndPointURL = "supplier/addsupllier";

export const updateSupplierEndPointURL = "supplier/editsupllier";
export const supplierAPI = "users/supplier/";
export const supplierBoatsAPI = "users/supplier-boats/";
export const toggleSupplierStatusAPI = "users/toggle-supplier-status/";

// Dock
export const addDockDetailsEndPointURL = "dock/addDock";
export const getDockDetailsEndPointURL = "dock/getAllDock";
export const deleteDockAPI = "dock/deleteDock/";

export const updateDockDetailsEndPointURL = "dock/updateDock";
export const getAvailableBoatsEndPointURL = "dock/availableBoats";

export const assignBoatsToDockEndPointURL = "dock/assignBoat";
export const getOwnersListEndPointURL = "users/owners";
export const dockUtilizationAPI = "dock/dock-utilization";

// Boats
export const getAllBoatsDataEndPointURL = "boat/getAllBoat";
export const getBoatDataByRegNoEndPointURL = "boat/getBoatByRegiratationId"; // MVP1 Ventures
export const addBoatDetailsEndPointURL = "boat/addBoat";
export const deleteBoatAPI = "boat/deleteBoat/";

export const updateBoatDetailsEndPointURL = "boat/updateBoat";

// Images Delete
export const deleteImageEndPointURL = "users/deleteFile";

// Task
export const createTaskEndPointURL = "task/addTask";
export const getAllBoatWithTasksEndPointURL = "task/getAllBoatsWithTasks";

export const updateTaskEndPointURL = "task/updateTask";
export const getAllTaskDataEndPointURL = "task/getAllTask";
export const deleteTaskEndPointURL = "task/deleteTask/";

export const getAllCompletedBoatTasksEndPointURL =
  "invoice/getAllCompletedTask/";

export const jobManagementAPI = "task/job-management"
export const jobDetailsAPI = "task/getJobDetailById/"
// Lead
export const getAllLeaddataEndPointURL = "quickLeads/getAllQuickLeads";
export const AddLeaddataEndPointURL = "quickLeads/addQuickLeads";

export const UpdateLeaddataEndPointURL = "quickLeads/updateQuickLeads";
export const RecouringReminderEndPointURL = "quickLeads/getDueRecurringTasks";

export const UpdateRecouringEndPointURL = "quickLeads/updateRecurringTask";

// Notification
export const notificationEndPointURL = "notification";

// Invoice
export const generateBoatInvoiceEndPointURL = "invoice/generateInvoice";
export const getGeneratedInvoiceEndPointURL = "invoice/getInvoiceById/";

export const getBoatListOfInvoiceEndPointURL =
  "invoice/getAllBoatsWithCompletedTasks";
export const sendInvoicePdfToBoatOwnerEndPointURL =
  "invoice/sendPdfToBoatOwner";
export const markInvoiceAsPaidEndPointURL = "invoice/markInvoiceAsPaid/";

// MVP1 Ventures
export const saveInvoicePdfEndPointURL = "invoice/saveInvoicePdf";
export const saveJobsheetPdfEndPointURL = "invoice/saveJobsheetPdf";

export const getAllInvoiceDataEndPointURL = "invoice/getAllInvoices";

// Subscriptions
export const getAllSubscriptionPlansEndPoitnURL = "subscription/allPlans";
export const getMySubscriptionPlansEndPoitnURL =
  "subscription/getMySubscriptionOrTrail";

export const cancelSubscriptionPlansEndPointURL =
  "subscription/cancelSubscription";
export const getSubscriptionHistoryEndPointURL =
  "subscription/getMySubscriptionHistory";

export const purchaseNewSubscriptionPlanEndPointURL = "subscription/buyNewPlan";
export const upgradeSubscriptionPlanEndPointURL =
  "subscription/upgradeSubscription";

// Xero Connect
export const getXerologinDataENDPOINTURL = "xero/connect";
export const pushInvoiceToXeroENDPOINTURL = "invoice/pushInvoiceToXero";

// Update Job Sheet
export const updateJobSheetENDPOINTURL = "users/updateJobSheet";

// Maintenance : 
export const maintenanceAPI = "Task/get-generated-tasks";
export const generateMaintenanceTaskAPI = "Task/generate-task";
export const MaintenanceDetailsAPI = "Task/get-generated-task/";
export const presetsAPI = "services/getAllServices";
export const presetByIdAPI = "services/getService/";
export const deletePresetAPI = "services/deleteService/";
export const addPresetAPI = "services/addService";
export const updatePresetAPI = "services/updateService";

//Parts management
export const addPartAPI = "users/parts";
export const getPartsAPI = "users/parts";
export const deletePartAPI = "users/parts/";
export const updatePartAPI = "users/parts/";
export const extraPartRequestsAPI = "users/extra-part-requests";
export const addExtraPartRequestPartAPI = "users/extra-part-requests/add-part";


// Analytics :
export const analyticsAPI = "analytics/getAnalyticsDashboard";

// Supplier user session actions
export const updateTaskTimerUserSessionAPI = "Task/updateTaskTimerUserSession";
export const completeTaskUserSessionAPI = "Task/completeTaskUserSession";
export const createPartRequestUserSessionAPI = "Task/createPartRequestUserSession";